import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";

/**
 * Helper functions to generate music suggestion endpoints.
 * These are separate from endpointsMetadata.ts since that file is auto-generated by the backend.
 */
export const musicEndpoints = {
  searchTracks: () => endpointsMetadata.musicSuggestions.searchTracks,

  getTracks: () => endpointsMetadata.musicSuggestions.getTracks,

  getSuggestions: (eventId: number) =>
    `${endpointsMetadata.musicSuggestions.getSuggestions}?eventId=${eventId}`,

  addSuggestion: (eventId: number) =>
    `${endpointsMetadata.musicSuggestions.addSuggestion}?eventId=${eventId}`,

  deleteSuggestion: (suggestionId: number) =>
    `${endpointsMetadata.musicSuggestions.deleteSuggestion}?suggestionId=${suggestionId}`,

  toggleUpvote: (suggestionId: number) =>
    `${endpointsMetadata.musicSuggestions.toggleUpvote}?suggestionId=${suggestionId}`,
};
